/**
 * @fileoverview Shared constants for the Change Password page.
 * @module pages/changePassword/changePasswordConstants
 */

/** OTP input border when there is a code error */
export const OTP_INPUT_BORDER_ERROR = "1px solid red";
/** OTP input border when there is no error */
export const OTP_INPUT_BORDER_NORMAL = "1px solid #909092";
/** OTP input text color when there is a code error */
export const OTP_INPUT_COLOR_ERROR = "red";
/** OTP input text color when there is no error */
export const OTP_INPUT_COLOR_NORMAL = "black";
/** OTP input border radius */
export const OTP_INPUT_BORDER_RADIUS = "8px";
export const OTP_INPUT_FONT_SIZE = "24px";
export const OTP_INPUT_SIZE_DEFAULT = "65px";
export const OTP_INPUT_SIZE_MEDIUM_MOBILE = "45px";
export const OTP_INPUT_SIZE_SMALL_MOBILE = "30px";

export const MIN_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 15;
export const REQUIRED_PASSWORD_RULE_MATCHES = 2;
export const PASSWORD_SUCCESS_REDIRECT_DELAY_MS = 2000;
export const OTP_NUM_INPUTS = 6;
export const OTP_MIN_LENGTH = 6;
export const MIN_INPUT_LENGTH = 1;

export const TABLET_MIN_WIDTH_PX = 768;
export const TABLET_MAX_WIDTH_PX = 1023;
export const MEDIUM_MOBILE_MIN_WIDTH_PX = 401;
export const MEDIUM_MOBILE_MAX_WIDTH_PX = 767;
export const SMALL_MOBILE_MAX_WIDTH_PX = 400;
